
/* eslint-disable */
import { mapGetters } from "vuex";
import ProductGallery from "~/components/products/ProductGallery";
import ProductNavSection from "~/components/products/ProductNavSection";
import ProductIntroduction from "~/components/products/ProductIntroduction";
import ProductTopFeatures from "~/components/products/ProductTopFeatures";
import ProductSpecification from "~/components/products/ProductSpecification";
import ProductInventories from "~/components/products/ProductInventories";
import InventoriesModal from "~/modals/InventoriesModal";
import ProductFaqs from "~/components/products/ProductFaqs.vue";

const components = {
  ProductGallery,
  ProductInventories,
  ProductNavSection,
  ProductIntroduction,
  ProductTopFeatures,
  ProductSpecification,
  ProductFaqs,
};

if (process.browser) {
  components.SpriteSpinCanvas =
    require("~/components/SpriteSpinCanvas.client.vue").default;
  window.bounty = require("bounty/lib/bounty.js").default;
}

export default {
  components,
  asyncData: async function ({ params, $axios, error }) {
    try {
      const { data } = await $axios.$get(
        `api/front/products/v2/${params.slug}?true`
      );

      let objData = {
        productTotalInventories: data.total_inventories,
        product: data.product,
        productAttributes: data.attributes,
        productGeometries: data.geometry,
        productTopFeatures: data.top_features,
        gallery: data.media.gallery.concat(
          data.media.colors.flatMap((e) => e.gallery)
        ),
        colors: data.media.colors,
        defaultColor: data.media.colors[0],
        variants: [],
      };

      objData.colors.forEach((element) => {
        if (element.menu.length >= 1) {
          objData.variants.push(true);
        }
      });

      objData.hasIntroduction = !!objData.product.description;
      (objData.hasSpecifications = !!objData.productAttributes),
        (objData.hasGallery = objData.gallery.length > 0),
        (objData.hasTopFeatures = objData.productTopFeatures.length > 0),
        (objData.hasGeometries = !!objData.productGeometries);

      objData.topData = objData.productAttributes
        .filter(
          (a) =>
            a.slug === "power" ||
            a.slug === "max-torque" ||
            a.slug === "dry-weight-kg"
        )
        .map(function (a) {
          return {
            name: a.name,
            content: a.values[0]["content"],
          };
        });

      /* if (objData.productGeometries && objData.productGeometries.sizes && objData.productGeometries.sizes[5] && objData.productGeometries.sizes[5][1]) {
        objData.topData.push({
          name: objData.productGeometries.sizes[5][1],
          content: objData.productGeometries.sizes[5][2] || 'N/A',
        })
      } */

      return objData;
    } catch (e) {
      error({ statusCode: 404 });
    }
  },
  data() {
    return {
      isProductPage: false,
      hasFaq: false,
    };
  },
  computed: {
    ...mapGetters({
      currentSite: "getCurrentSite",
    }),
    currencyToken() {
      return this.currentSite && this.currentSite.default_currency_token
        ? this.currentSite.default_currency_token
        : "$";
    },
  },
  watch: {
    $route() {
      if (window.location.href.includes("/products/")) {
        this.isProductPage = true;
      } else {
        this.isProductPage = false;
      }
    },
  },
  head() {
    return {
      title: this.product.name,
    };
  },
  mounted() {
    if (process.browser) {
      this.isProductPage = window.location.href.includes("/products/");

      // Object.keys(this.topData).forEach((obj, index) => {
      //   if (index >= 0) {
      //     window.bounty({
      //       el: `.bounty-${index}`,
      //       value: this.topData[index].content,
      //       duration: 1500,
      //       animationDelay: 200 * (index + 1)
      //     })
      //   }
      // })

      // Power
      // window.bounty({
      //   el: '.bounty-power',
      //   value: this.topData[0]?.content ? this.topData[0].content : 'N/A',
      //   duration: 1500,
      //   animationDelay: 200
      // })

      // Max torque
      // window.bounty({
      //   el: '.bounty-max-torque',
      //   value: this.topData[1]?.content ? this.topData[1].content : 'N/A',
      //   duration: 1500,
      //   animationDelay: 200
      // })

      // Seat height
      // window.bounty({
      //   el: '.bounty-dry-weight',
      //   value: this.topData[2]?.content ? this.topData[2].content : 'N/A',
      //   duration: 1500,
      //   animationDelay: 200
      // })

      // Price
      // window.bounty({
      //   el: '.bounty-price-from',
      //   value: this._data.product.min_price ? `$${this._data.product.min_price}` : 'N/A',
      //   duration: 1500,
      //   animationDelay: 200
      // })

      // window.bounty({
      //   el: '.bounty-total-inventory',
      //   value: this._data.productTotalInventories,
      //   duration: 1500,
      //   animationDelay: 200
      // })

      if (window.gtag) {
        window.gtag("event", "view_item", {
          items: [
            {
              id: this.product.slug,
              name: this.product.name,
            },
          ],
        });
      }

      this.$nextTick(() => {
        const videos = document.querySelectorAll("video");

        if (videos.length >= 1) {
          const options = {
            rootMargin: "0px 0px -20% 0px",
          };

          const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.play();
              } else {
                entry.target.pause();
              }
            });
          }, options);

          Array.prototype.forEach.call(videos, (video) => {
            observer.observe(video);
          });
        }
      });
    }
  },
  methods: {
    setFaq(e) {
      this.hasFaq = e;
    },
    openInventoriesModal() {
      this.$modal.show(
        InventoriesModal,
        {
          productSlug: this.product.slug,
        },
        {
          height: "80%",
          maxWidth: 1280,
        }
      );
    },
  },
};
